import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import NotificationsSystem from 'reapop';
// import LogRocket from 'logrocket';
import history from './history';
import { setConfig } from './actions/config';
import { authCheckState } from './actions/authActionCreators';

// import { indexOf } from 'lodash';
import theme from './notifications/reapop/reapop-theme-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';

// global css
import './css/bootstrap/scss/bootstrap.css';
import './css/main.css';
import './css/ui-elements/typography.css';
import './css/ui-elements/cards.css';
import './css/ui-elements/buttons.css';
import './css/icons/simple-line-icons.css';

// structural elements
import LeftSidebar from './elements/LeftSidebar';
import RightSidebar1 from './elements/right-sidebar/Index';
import Navbar1 from './elements/Navbar1';
import Spinner from './components/UI/Spinner';
import HistoryNotesModal from './components/modals/HistoryNotesModal';
import AlertModal from './components/UI/AlertModal';

import Routes from './Routes';

// const { REACT_APP_LOGROCKET_ID: logrocketId } = process.env;

// after calling LogRocket.init()
// LogRocket.init(logrocketId);
// LogRocket.identify(window.localStorage.getItem('referenceCode'), {
//   name: window.localStorage.getItem('name'),
//   email: window.localStorage.getItem('email'),
// });

class App extends Component {
  constructor() {
    super();
    this.setLayout = this.setLayout.bind(this);
    history.listen(location => {
      this.setLayout(location.pathname);
    });
  }

  componentWillMount() {
    const { pathname } = this.props;
    this.setLayout(pathname);
  }

  setLayout() {
    const {
      isAuthenticated,
      setConfig: setAppConfig,
      authCheckState: checkAuthState,
    } = this.props;
    if (isAuthenticated) {
      setAppConfig('layout', 'default-sidebar-1');
      checkAuthState();
    } else setAppConfig('layout', 'empty-view-1');
  }

  render() {
    const { config } = this.props;
    const {
      layout,
      background,
      navbar,
      logo,
      leftSidebar,
      topNavigation,
      collapsed,
    } = config;
    const isEmptyView = layout === 'empty-view-1';
    return (
      <ConnectedRouter history={history}>
        <div
          data-layout={layout}
          data-background={background}
          data-navbar={navbar}
          data-logo={logo}
          data-left-sidebar={leftSidebar}
          data-top-navigation={topNavigation}
          data-collapsed={collapsed}
        >
          <Spinner />
          <HistoryNotesModal />
          <NotificationsSystem theme={theme} />
          <AlertModal />
          <RightSidebar1 />
          <Navbar1 />
          {/* <TopNavigation1 /> */}
          <div className={isEmptyView ? '' : 'container-fluid'}>
            <div className={isEmptyView ? '' : 'row'}>
              <LeftSidebar />
              {/* <LeftSidebar2 /> */}
              <div className={isEmptyView ? '' : 'col main'}>
                {/* <Jumbotron1 /> */}
                <Routes />
              </div>
            </div>
          </div>
        </div>
      </ConnectedRouter>
    );
  }
}

const mapStateToProps = state => {
  const { token } = state.auth;
  return {
    config: state.config,
    isAuthenticated: !!token,
  };
};

export default connect(
  mapStateToProps,
  { setConfig, authCheckState }
)(App);



// WEBPACK FOOTER //
// ./src/App.js